import { useEffect, useState, useRef } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import api from "@/lib/api";
import { Check, X, Loader2 } from "lucide-react";

export default function PayPalReturnPage() {
  const { t } = useTranslation();
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const orderId = params.get("order_id");
  const [status, setStatus] = useState("processing");
  const [order, setOrder] = useState(null);
  const captured = useRef(false);

  useEffect(() => {
    if (!orderId || captured.current) return;
    captured.current = true;
    (async () => {
      try {
        const { data } = await api.post("/payments/paypal/capture", { order_id: orderId });
        if (data.payment_status === "PAYMENT_CONFIRMED") {
          setStatus("success");
          try { const { data: o } = await api.get(`/orders/${orderId}`); setOrder(o); } catch {}
        } else {
          setStatus("failed");
        }
      } catch {
        setStatus("failed");
      }
    })();
  }, [orderId]);

  if (status === "processing") {
    return (
      <div className="min-h-full flex flex-col items-center justify-center py-16 px-6">
        <Loader2 size={40} className="animate-spin text-[#999] mb-4" />
        <p className="text-sm text-[#999]">{t("paypal_return.processing")}</p>
      </div>
    );
  }

  if (status === "failed") {
    return (
      <div className="min-h-full flex flex-col items-center justify-center py-16 px-6">
        <div className="w-16 h-16 rounded-full bg-red-100 flex items-center justify-center mb-4">
          <X size={32} className="text-red-600" />
        </div>
        <h2 className="text-lg font-bold text-[#0A0A0A]">{t("paypal_return.failed_title")}</h2>
        <p className="text-sm text-[#999] mt-2 text-center">{t("paypal_return.failed_body")}</p>
        <button onClick={() => navigate(-1)} className="mt-6 rounded-full h-10 px-6 bg-[#0A0A0A] text-white text-sm font-medium">{t("paypal_return.back")}</button>
      </div>
    );
  }

  return (
    <div data-testid="paypal-return-success" className="min-h-full flex flex-col items-center justify-center py-16 px-6">
      <div className="w-16 h-16 rounded-full bg-green-100 flex items-center justify-center mb-4">
        <Check size={32} className="text-green-600" />
      </div>
      <h2 className="text-lg font-bold text-[#0A0A0A]">{t("paypal_return.success")}</h2>
      {order && (
        <div className="mt-4 border border-[#E5E5E5] p-4 w-full max-w-sm">
          <p className="text-sm font-medium">{order.title}</p>
          <p className="text-xl font-bold mt-1">{order.price?.toFixed(2)} {order.currency}</p>
          <p className="text-xs text-[#999] mt-1">Bestellnr: <span className="font-mono">{order.order_id}</span></p>
        </div>
      )}
      <button onClick={() => navigate("/profile/orders")} className="mt-6 rounded-full h-10 px-6 bg-[#0A0A0A] text-white text-sm font-medium">Zu meinen Bestellungen</button>
    </div>
  );
}
